import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/help/tutorials/market")({
  component: MarketHelp,
});

const QAData = [
    {
        question: "什么是“集市”？它面向哪些用户开放？",
        answer: "集市是一个用于买卖物品的平台，目前面向所有实名用户开放，您可以在集市中上架物品，目前我们仅支持“虚拟物品”交易，如模板出商等等等。"
    }, {
        question: "在集市发布商品时，有哪些要求？",
        answer: "发布商品时，您需要提供商品的名称、描述、价格、分类、标签、图片等信息。这些信息可以帮助买家更清楚的知道您出售的商品内容，让交易更加顺畅哦～"
    }, {
        question: "集市的交易步骤是怎样的？",
        answer: "简单来说，交易步骤分为【支付、等待发货、等待确认收货、完成收货】四个步骤。当您决定下单某个商品时，您首先需要支付订单。支付完成后，等待卖家进行发货。当卖家发货以后，您可以先行查收文件，如果文件符合要求就可以点击确认收货，到这里，交易就完成啦。"
    }, {
        question: "商品中的“需要绑定QQ号”是什么？",
        answer: "在集市中，为了符合圈内的“打标”需求，有些商品需要买家绑定QQ号才能购买，所以购买前需要到“我的——编辑个人资料”中填写QQ号才可以购买哦。"
    }, {
        question: "商品中的“实体商用权”指的是什么？",
        answer: "在商用模板中，除了模板接稿以外，还有一种特殊的使用场景：“周边产品”。我们称之为“实体打印商用权”，这个权利可以允许您购买这个模板以后，用来打印周边（如亚克力，布袋、T恤、抱枕等等）进行贩售的一种权利。"
    }, {
        question: "如果我是购买方，需要实名认证吗？",
        answer: "不需要，但画师可以在订单界面查看您的实名认证状态，如果您没有实名认证，谨慎的画师为了减少流模风险，可能会拒绝您的交易哦。"
    }, {
        question: "如果我是卖家，发货以后发现有遗漏的文件，我还可以继续补充发货吗？",
        answer: "可以，您可以在订单中继续上传文件，而且在买家确认收货7天内，您依然可以不限次数的补充上传文件。"
    }, {
        question: "如果我想退单，有什么限制？",
        answer: "对买家来说，当没有支付时，您可以随时关闭订单。如果您已完成了支付，则需要和卖家沟通，联系卖家取消订单。但请注意，如果您频繁或被判定为恶意取消订单，您将可能被限制交易哦~"
    }, {
        question: "如果我给买家发了货，买家却以“我没有下载过，可不可以取消订单”为理由要求退单，我该怎么办？",
        answer: "退单的情况可能有各种各样的原因，因此我们给予卖家随时给买家退款的权利。当买家下载了文件时，系统会给卖家发送推送消息，并且会记录下载次数。如果买家以“没有下载过”为理由要求退单，您可以和买家沟通，如果您认为买家的理由不充分，您可以拒绝退单。"
    }, {
        question: "我没有身份证，可以实名认证吗？",
        answer: "如果您是移民或外籍用户，您可以在“我的——设置——帮助与反馈”中选择“账户相关问题”，并上传您的护照信息+备注“实名认证”进行人工认证。"
    }, {
        question: "我遇到了BUG！有什么办法可以解决吗？",
        answer: "您可以在“我的——设置——帮助与反馈”中提交您的问题，为了我们更快的帮助到您，您可以尽量详细的描述问题触发的原因，并附上问题的截屏，我们会尽快协助解决您的问题哦~"
    }
]


export default function MarketHelp() {
    return (
        <div>
            <div className={"relative flex items-center max-h-48 overflow-hidden"}>
                <div className={"flex flex-col gap-2 absolute f2a-1/4 left-16"}>
                    <div className={"text-5xl"}>集市</div>
                    <div className={"text-xl text-gray-500"}>常见问题FAQ</div>
                </div>
                <img className={"ml-auto w-128 h-48"} src="/img/tutorial/market_banner.png" alt="App Usage" />
            </div>
            <div className={"mx-4 mb-8"}>
                {
                    QAData.map((qa, index) => {
                        return (
                            <div key={index} className={"flex flex-col gap-1 mt-8"}>
                                <div className={"text-primary font-bold"}>Q：{qa.question}</div>
                                <div className={"text-gray-800"}>A：{qa.answer}</div>
                            </div>
                        )
                    })
                }
            </div>
        </div>
    )
}
